var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/pause.c48d7931.png","uri@2x": __webpack_public_path__ + "static/media/pause.f7ba63a0.png","uri@3x": __webpack_public_path__ + "static/media/pause.91234de5.png",
    width: 60,
    height: 64
});